var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarElement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0l4.323 6.788 6.659-4.41 1.238 7.991 7.845-1.27-2.06 7.814 7.673 2.089-5.002 6.285 6.176 5.088-7.08 3.668 3.61 7.207-7.932.419.42 8.079-7.414-2.904-2.842 7.555L27 48.675l-5.614 5.724-2.842-7.555-7.414 2.904.42-8.08-7.933-.418 3.61-7.207-7.08-3.668 6.177-5.088-5.003-6.285 7.674-2.09L6.935 9.1l7.845 1.27 1.238-7.992 6.66 4.41L27 0z"
  })));
}
export default SvgStarElement;